import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaTipoContrato = () => {
  return (
    <MetricaBase
      titulo="Tipo de Contrato"
      descricao="Análise da distribuição de colaboradores ativos por tipo de contrato (CLT/PJ)"
      endpoint="tipo-contrato"
      tipoDownload="tipo-contrato"
      cor="lime"
      mostrarGraficoArea={false}
    />
  );
};

export default MetricaTipoContrato;